module.exports = __webpack_public_path__ + "img/ico_xfjc.bf7587c6.png";